import { EducationLevel, type ScenarioGenerationSettingsDTO } from '@superlekcja/shared'

/*
  SZKIC FORMULARZA NOWEJ LEKCJI — przezywa przeladowanie strony.

  Logowanie przez Google i link weryfikacyjny z maila przeladowuja aplikacje, a temat zyl tylko
  w stanie Reacta: niezalogowany nauczyciel wpisywal temat, klikal „Generuj", logowal sie
  i dostawal pusty formularz. localStorage, nie sessionStorage — link z maila otwiera NOWA karte.

  To zapis niezbedny do funkcji, o ktora uzytkownik prosi (jego wlasny tekst), wiec nie czeka
  na zgode na cookies analityczne. Czyszczony po utworzeniu lekcji i przy wylogowaniu
  (wspolne komputery w szkole), a po dobie i tak wygasa.
*/

export type LessonDraft = { prompt: string; settings: ScenarioGenerationSettingsDTO }

export const LESSON_DRAFT_STORAGE_KEY = 'superlekcja.lesson-draft'
const TTL_MS = 24 * 60 * 60 * 1000

type StoredDraft = LessonDraft & { savedAt: number }

const EDUCATION_LEVELS = new Set<unknown>(Object.values(EducationLevel)) // liczby 0..6

function isStoredDraft(value: unknown): value is StoredDraft {
  if (!value || typeof value !== 'object') return false
  const v = value as Record<string, any>
  return typeof v.prompt === 'string'
    && typeof v.savedAt === 'number'
    && typeof v.settings?.duration === 'number'
    && EDUCATION_LEVELS.has(v.settings?.educationLevel)
}

export function loadLessonDraft(): LessonDraft | null {
  try {
    const raw = localStorage.getItem(LESSON_DRAFT_STORAGE_KEY)
    if (!raw) return null
    const parsed: unknown = JSON.parse(raw)
    if (!isStoredDraft(parsed) || Date.now() - parsed.savedAt > TTL_MS) {
      localStorage.removeItem(LESSON_DRAFT_STORAGE_KEY)
      return null
    }
    return { prompt: parsed.prompt, settings: parsed.settings }
  } catch (err) {
    // Zepsuty JSON albo storage niedostepny (tryb prywatny). Szkic to wygoda — strona ma dzialac.
    console.warn('lesson draft: ignoring unreadable draft', err)
    try { localStorage.removeItem(LESSON_DRAFT_STORAGE_KEY) } catch { /* storage niedostepny */ }
    return null
  }
}

export function saveLessonDraft(draft: LessonDraft): void {
  try {
    const stored: StoredDraft = { ...draft, savedAt: Date.now() }
    localStorage.setItem(LESSON_DRAFT_STORAGE_KEY, JSON.stringify(stored))
  } catch (err) {
    console.warn('lesson draft: cannot save', err)
  }
}

export function clearLessonDraft(): void {
  try {
    localStorage.removeItem(LESSON_DRAFT_STORAGE_KEY)
  } catch (err) {
    console.warn('lesson draft: cannot clear', err)
  }
}
